module.exports = __webpack_public_path__ + "img/mobilehardware3.08480c80.png";